import invariant from 'tiny-invariant';
import { sendParent } from 'xstate';
import { DoneMessage } from '..';
import { isDoneMessage } from '../helpers';
import { StopActorMessage } from '../types';

export let requestStop = sendParent<any, any, StopActorMessage>((ctx) => {
  invariant('id' in ctx);
  return { type: 'stop_child', id: ctx.id };
});

export let sendResponse = sendParent<any, any, DoneMessage>((_, message) => {
  isDoneMessage(message);
  return message;
});
